module.exports = __webpack_public_path__ + "img/pc-bg.1a70a714.webp";